import qs from 'query-string';
import { useCallback, useState } from 'react';
function useQueryString(key, initialValue, isboolean) {
    const setQueryStringWithoutPageReload = (qsValue) => {
        const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + (qsValue ? '?' + qsValue : '');
        window.history.pushState({ path: newurl }, '', newurl);
    };
    const getQueryStringValue = (key) => {
        const values = qs.parse(window.location.search);
        let value = values[key];
        return isboolean ? !!value : value;
    };
    function setQueryStringValue(key, value) {
        const values = qs.parse(window.location.search);
        const newvalues = Object.assign(Object.assign({}, values), { [key]: value });
        if (isboolean && !value) {
            delete newvalues[key];
        }
        const newQsValue = qs.stringify(newvalues);
        setQueryStringWithoutPageReload(newQsValue);
    }
    const onSetValue = useCallback((newValue) => {
        let newvaltyped = isboolean ? !!newValue || undefined : newValue;
        setValue(newvaltyped);
        setQueryStringValue(key, newvaltyped);
    }, [key]);
    const [value, setValue] = useState(getQueryStringValue(key) || initialValue);
    return [value, onSetValue];
}
export default useQueryString;
